export default __webpack_public_path__ + "static/media/apple-iMac.86dece35.jpg";